<template>
  <div id="accordion" class="w-100">
    <div class="">
      <div 
      :class="isOpen ? customClass + ' cursor-pointer ' : customClass + '  cursor-pointer border-bottom border-primary ' " 
  
      :id="'headingOne' + mykey">
        
          <span
            class="w-100 text-left text-primary"
            :class="
              (open ? '' : 'collapsed') && classButton != ''
                ? classButton
                : 'p-2'
            "
            data-toggle="collapse"
            :data-target="'#collapseOne' + mykey"
            aria-expanded="false"
            :aria-controls="'collapseOne' + mykey"
            @click="openNow()"
          >
           <i class="icon icon-minus text-primary" v-if="!isOpen"></i>
            <i class="icon icon-plus text-primary" v-else></i> 
            {{ title }}
            <span v-html="titleHtml"></span>
          </span>
        
      </div>
      <div
        :id="'collapseOne' + mykey"
        :class="open ? 'show' : ''"
        class="collapse  p-4 border-primary border rounded"
        :aria-labelledby="'headingOne' + mykey"
        data-parent="#accordion"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  data() {
    return {
      isOpen: false
    };
  },

  props: {
    title: String,
    titleHtml: String,
    mykey: Number,
    open: Boolean,
    customClass: String,
    classButton: {
      default: ""
    }
  },

  created() {
    this.isOpen = this.open;
  },
  methods: {
    openNow() {
      if (!this.isOpen) {
        this.$emit("opennow");
        this.isOpen = true;
      } else {
        this.isOpen = false;
      }
    }
  }
};
</script>
<style scoped>
.btn:focus {
  box-shadow: none;
}
</style>
